import styled from '@emotion/styled';

export const Container = styled.div`
  max-width: 326px;
  overflow: hidden;
`;

export const ListContainer = styled.div`
  display: flex;
  gap: 2px;
  width: fit-content;
`;
